import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { ManageIcon } from '@dndbeyond/character-components/es';
import { CharacterTheme, rulesEngineSelectors, SenseInfo } from '@dndbeyond/character-rules-engine/es';

import { sidebarActions } from '../../../Shared/actions';
import { Subsection, SubsectionFooter } from '../../../Shared/components/Subsection';
import { appEnvSelectors } from '../../../Shared/selectors';
import { AppEnvDimensionsState } from '../../../Shared/stores/typings';
import { PaneComponentEnum } from '../../../Shared/utils';
import SensesBox from '../../components/SensesBox';
import { SheetAppState } from '../../typings';

interface Props extends DispatchProp {
    passivePerception: number;
    passiveInvestigation: number;
    passiveInsight: number;
    senses: SenseInfo;
    dimensions: AppEnvDimensionsState;
    theme: CharacterTheme;
    isReadonly: boolean;
}
class SensesDesktop extends React.PureComponent<Props> {
    handleManageShow = (): void => {
        const { dispatch } = this.props;

        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.SENSE_MANAGE));
    };

    render() {
        const { passiveInsight, passiveInvestigation, passivePerception, senses, isReadonly, dimensions, theme } =
            this.props;

        return (
            <Subsection name="Senses" className="ct-senses-desktop">
                <SensesBox
                    senses={senses}
                    passiveInsight={passiveInsight}
                    passiveInvestigation={passiveInvestigation}
                    passivePerception={passivePerception}
                    onClick={this.handleManageShow}
                    dimensions={dimensions}
                    theme={theme}
                />
                <SubsectionFooter>
                    <ManageIcon onClick={this.handleManageShow} tooltip={isReadonly ? 'View' : 'Manage'} theme={theme}>
                        Senses
                    </ManageIcon>
                </SubsectionFooter>
            </Subsection>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        passivePerception: rulesEngineSelectors.getPassivePerception(state),
        passiveInvestigation: rulesEngineSelectors.getPassiveInvestigation(state),
        passiveInsight: rulesEngineSelectors.getPassiveInsight(state),
        senses: rulesEngineSelectors.getSenseInfo(state),
        dimensions: appEnvSelectors.getDimensions(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
    };
}

export default connect(mapStateToProps)(SensesDesktop);
